import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home-page',
    meta: { title: '首页' },
    component: async() => await import(/* webpackChunkName: "home" */ '../views/home-page/index.vue')
  },
  {
    path: '/default-page/:code',
    name: 'default-page',
    meta: { title: '' },
    component: async() => await import(/* webpackChunkName: "home" */ '../views/default-page/index.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior() {
    return { top: 0, left: 0 }
  },
  routes
})

export default router
